<template>
  <div
    class="previous-order-wrap"
    v-if="isLoggedIn && previousOrderData.length > 0"
  >
    <div class="previous-order-header">
      <span class="previous-order-title pl16 fs-16 bold">{{
        modulePropsData?.title
      }}</span>
      <span class="view-all-cta pr16 medium" @click="viewAllCTAHandle">{{
        modulePropsData?.viewAllCta
      }}</span>
    </div>
    <div class="previous-order-cards-wrap">
      <div
        class="custom-offer-carousel pl16"
        :class="previousOrderData.length > 1 ? '' : 'pr16'"
      >
        <div
          v-for="order in previousOrderData"
          :key="order?.id"
          :class="{
            pr16: clientPlatform == 'Web',
          }"
        >
          <product-card
            :smallCards="true"
            :isOnCartPage="false"
            :quantity="getQuantity(order)"
            :hideProductImg="false"
            :imageSrc="getProductImg(order)"
            :isVeg="order?.product?.foodType === 'VEG'"
            :displayName="order?.product?.name"
            :currentPrice="getCurrentPrice(order)"
            :cardSizeReorder="true"
            @removefromcart="removefromcart(order)"
            @addtocart="addtocart(order)"
            :variantNoPadding="isVariantWithNoPadding"
          ></product-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, mediaBaseUrlDefault } from "../config/apiEndpoints";
import { clientPlatform } from "../config/apiEndpoints";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import OrderItemCard from "./OrderItemCard.vue";
import PageNames from "../config/pageNames";
import { EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS } from "../helpers/analyticsEvents";
import ProductCard from "./ProductCard.vue";

export default {
  name: "PreviousOrder",
  components: {
    OrderItemCard,
    ProductCard,
  },
  props: ["moduleProps"],
  data() {
    return {
      staticImgBaseUrl,
      PageNames,
      modulePropsData: {},
      quantity: 0,
      clientPlatform,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    reorderCtaHandle() {},
    getDateInFormat(timestamp) {
      if (timestamp == "") {
        return "";
      }
      return Utility.getDateStringFromTimeStamp(timestamp);
    },
    viewAllCTAHandle() {
      EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS();
      LocalStorageFunc.setOrderHistoryPage(OrderHistoryPages.MY_ORDERS);
      Utility.sendToOrderHistory();
    },
    getProductImg(productItem) {
      let mediaBaseUrl = this.reorderData?.mediaBaseURL || "";
      let item =
        this.reorderData?.comboDefinitions?.find(
          (x) => x.skuId === productItem.skuId
        ) ||
        this.reorderData?.productDefinitions?.find((x) =>
          x.variants.some((y) => y.skuId === productItem.skuId)
        );

      let img =
        item?.mediaList?.[0]?.mediaUrls?.thumbnail ||
        item?.mediaList?.[0]?.mediaUrls?.HomeProductV1;
      return img && img.includes("https")
        ? img
        : mediaBaseUrl + img ||
            staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg";
    },
    getCurrentPrice(order) {
      return parseFloat(order?.pricePerQty?.toFixed(2));
    },
    addtocart(item) {
      if (item?.childItems && item?.childItems?.length) {
        let product =
          this.$store.state.ProductItems.products[
            Object.keys(
              this.$store.state.ProductItems.productCategoryMap[item?.skuId]
            )[0]
          ][item?.skuId];
        let invalidItem = item?.childItems?.find(
          (x) => x.inactive || x.variantInactive
        );
        if (invalidItem && Object.keys(invalidItem).length) {
          let cartItems = LocalStorageFunc.getCart();
          if (
            cartItems[Utility.getProductSkuId(product)] &&
            cartItems[Utility.getProductSkuId(product)].length > 0
          ) {
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL,
              true
            );
          } else {
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
              true
            );
          }
          this.updateShowCustomisableFor(product);
          return;
        } else {
          let changedPrice = {
            currentPrice: item.pricePerQty,
            regularPrice: product?.price?.regularPrice,
          };
          let customizationOptions = product?.groups.map((group) => {
            return {
              ...group,
              items: group.items.map((item) => {
                let productDetail = {};
                this.reorderData.productDefinitions.map((i) => {
                  if (i.parentSkuId == item.parentSkuId) {
                    i.isVeg = Utility.getIsVegFoodType(i);
                    productDetail = i;
                  }
                });
                return {
                  ...item,
                  productDetails: productDetail,
                };
              }),
            };
          });
          let groupsFromOrder = item?.childItems || [];
          let productForCart = {
            ...product,
            price: changedPrice,
            selectedComboVariant: product.groups.map((group, index) => {
              return {
                ...group,
                items: [
                  ...group.items.filter((comboItem, originalSelectIndex) => {
                    return (
                      comboItem.parentSkuId ==
                        groupsFromOrder[index]?.parentId &&
                      comboItem?.products?.[0]?.skuId ==
                        groupsFromOrder[index]?.skuId
                    );
                  }),
                ],
              };
            }),
            customizationOptions: customizationOptions,
          };
          // for (let step = 0; step < item?.quantity; step++) {
          //   this.$store.commit(keyMapsMutation.ADD_TO_CART, productForCart);
          // }
          this.$store.commit(keyMapsMutation.ADD_TO_CART, productForCart);
        }
      } else {
        // handling for non combo items
        let product =
          this.$store.state.ProductItems.products[
            Object.keys(
              this.$store.state.ProductItems.productCategoryMap[item?.parentId]
            )[0]
          ][item?.parentId];
        let selectedVariant = product?.variants?.filter(
          (variant) => variant.skuId == item?.skuId
        )[0];
        // for (let step = 0; step < item?.quantity; step++) {
        //   this.$store.commit(keyMapsMutation.ADD_TO_CART, {
        //     ...product,
        //     selectedVariant: selectedVariant,
        //   });
        // }
        this.$store.commit(keyMapsMutation.ADD_TO_CART, {
          ...product,
          selectedVariant: selectedVariant,
        });
      }
      // reseting the same data to trigger store update
      this.$store.commit(keyMapsMutation.UPDATE_REORDER_DATA, [
        ...this.previousOrderData,
      ]);
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_ITEMS,
        LocalStorageFunc.getCart()
      );
    },
    removefromcart(order) {
      let productItem =
        this.reorderData?.comboDefinitions?.find(
          (x) => x.skuId === order.skuId
        ) ||
        this.reorderData?.productDefinitions?.find((x) =>
          x.variants.some((y) => y.skuId === order.skuId)
        );
      this.$store.commit(keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_CARD, {
        categoryId: this.dataCategoryId,
        index: this.dataItemIndex + 1,
      });
      let cartItems = LocalStorageFunc.getCart();
      let itemId = Utility.getProductSkuId(productItem);
      let editItemsListMiniCartCust = {};
      if (
        (productItem?.variants?.length > 0 &&
          productItem?.variants?.[0].attributes?.length > 0 &&
          cartItems[itemId] &&
          cartItems[itemId].length > 1) ||
        productItem?.comboUID
      ) {
        let cartItemsArray = Object.values(
          JSON.parse(JSON.stringify(this.$store.state.Cart.items))
        );
        let i = 0,
          j = 0;
        cartItemsArray.map((x) => {
          if (x[0]?.productMasterUID == itemId || x[0]?.comboUID == itemId) {
            j = i;
            return j;
          } else {
            i++;
          }
        });
        cartItemsArray[j]?.map((item) => {
          let key = "";
          if (item?.selectedVariant) {
            let productItemID = item?.selectedVariant?.productUID;
            key = item.productMasterUID + "*" + productItemID;
          } else {
            let productItemsIdArray = item?.selectedComboVariant
              ?.map((x) => x?.items?.map((i) => i?.productMasterId))
              .flat();
            key = item.comboUID + "*" + productItemsIdArray.join("*");
          }
          editItemsListMiniCartCust[key] = item;
        });
        if (Object.keys(editItemsListMiniCartCust).length > 1) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_EDIT_MINI_CART_MODAL,
            true
          );
          this.updateShowCustomisableFor(productItem);
        } else {
          this.$store.commit(
            keyMapsMutation.REMOVE_FROM_CART,
            this.getLastAddedItemFromCart(Utility.getProductSkuId(productItem))
          );
          this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
          this.$store.commit(
            keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
            "1 Item removed from the cart."
          );
          setTimeout(this.updateDisableItemToastMsg, 1000);
        }
      } else {
        this.$store.commit(
          keyMapsMutation.REMOVE_FROM_CART,
          this.getLastAddedItemFromCart(Utility.getProductSkuId(productItem))
        );
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
        this.$store.commit(
          keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
          "1 Item removed from the cart."
        );
        setTimeout(this.updateDisableItemToastMsg, 1000);
      }
      // reseting the same data to trigger store update
      this.$store.commit(keyMapsMutation.UPDATE_REORDER_DATA, [
        ...this.previousOrderData,
      ]);
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_ITEMS,
        LocalStorageFunc.getCart()
      );
    },
    getQuantity(order) {
      let quantity = this.$store.state.Cart.items[order?.parentId]?.filter(
        (x) =>
          x.skuId === order?.skuId || x?.selectedVariant?.skuId === order?.skuId
      )?.length;
      return quantity;
    },
    updateShowCustomisableFor(productItem) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR,
        Utility.getProductSkuId(productItem)
      );
    },
    isVariantWithNoPadding() {
      return this.modulePropsData?.isVariantWithNoPadding === "true" || false;
    },
  },
  computed: {
    previousOrderData() {
      return this.$store.state.ReOrder.previousOrderData;
    },
    reorderData() {
      return this.$store.state.ReOrder.reorderData;
    },
    isLoggedIn() {
      if (LocalStorageFunc.isLoggedIn()) {
        this.$store.dispatch(keyMapsAction.GET_PREVIOUS_ORDER_DATA, true);
      }
      return LocalStorageFunc.isLoggedIn();
    },
    getLastAddedItemFromCart() {
      return (productId) => {
        return this.$store.getters[keyMapsGetter.GET_LAST_ADDED_ITEM_FROM_CART](
          productId
        );
      };
    },
  },
};
</script>

<style></style>
